<template>
    <div class="list">
        <NavBar></NavBar>
        <div>
            <van-col span='24' style="font-size:20px;font-weight:bold;text-align:center;padding-top:10px">{{title}}</van-col>
            <van-col span='24' style="font-size:12px;text-align:center;color:gray;margin:12px 0">{{createTime.substring(0,10)}}</van-col>
            <div style="padding:0px 15px">
                <div v-html="content"></div>
            </div>
            <div style="background-color:#fff;position:fixed;bottom:0;left:0;right:0">
                <van-divider :style="{ color: 'gray', borderColor: 'gray', padding: '0 16px',fontSize:'12px'}">
                    {{createusername}}
                </van-divider>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data() {
      return{
          createusername:'',
          content:'',
          createTime:'',
          title:''
      }  
    },
    created(){
        console.log(this.$route.params)
        this.content = this.$route.params.content
        this.createTime = this.$route.params.createtime
        this.title = this.$route.params.title
        this.createusername = this.$route.params.createusername
    }
}
</script>

<style scoped>
.list {
    margin-top: 46px;
}
</style>